import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface ISnackbarConf {
  text: string;
  color: string;
  icon: string;
  ctaButton: boolean;
  ctaLabel: string;
  ctaLabelColor: string;
}

@Component({
  selector: 'app-customs-snackbar',
  templateUrl: './customs-snackbar.component.html',
  styleUrls: ['./customs-snackbar.component.scss'],
})
export class CustomsSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarConf, public snackBarRef: MatSnackBarRef<CustomsSnackbarComponent>) {}
}
